import { appName } from "@getdevpulse/settings/browser"
import { getAnalyticsPixelUrl } from "../lib/analytics"

/**
 * AnalyticsPixel Component
 *
 * Renders an invisible 1x1 pixel image for analytics tracking.
 * The pixel URL encodes the project name and source in base64 format.
 *
 * @example
 * ```tsx
 * <AnalyticsPixel source="homepage" />
 * ```
 */
export function AnalyticsPixel({ source = "main" }: { source?: string }) {
  const pixelUrl = getAnalyticsPixelUrl(appName, source)

  return (
    <img
      src={pixelUrl}
      alt=""
      aria-hidden="true"
      style={{
        position: "absolute",
        width: "1px",
        height: "1px",
        opacity: 0,
        pointerEvents: "none",
      }}
    />
  )
}
